export default class ProductImageMobileCarousel {
  constructor() {
    this.currentMedia = null

    this.isSuggestedPairing = false
    this.prodImageCarouselSelectedIndex = 0;
    this.prodImageCarouselAutoInterval = null;
    this.prodImageCarouselTouch = null;
    this.prodImageCarouselSwipeableElements = null

    this.build()
  }

  build() {
    document.addEventListener('updateprodimagecarousel', async (event) => {
      this.currentMedia = event.detail.mediaData
      this.isSuggestedPairing = event.detail.isSuggestedPairing
      this.updateprodImageCarousel()
    });
  
    const prodImageCarouselSwipeableObject = document.getElementById('prod-carousel-swipeable-object')
    prodImageCarouselSwipeableObject.addEventListener('click', () => this.checkAndPlayVideo())
    prodImageCarouselSwipeableObject.addEventListener('touchstart', (event) => this.prodImageCarouselTouchstart(event));
    prodImageCarouselSwipeableObject.addEventListener('touchend', (event) => this.prodImageCarouselTouchend(event));

    document.getElementById('prev-arrow').addEventListener('click', () => this.prevProdImagePress())
    document.getElementById('next-arrow').addEventListener('click', () => this.nextProdImagePress())
  }

  updateprodImageCarousel() {
    const prodImageCarouselParent = document.getElementById('prod-carousel-parent')
    const prodImageCarouselDotContainer = document.getElementById('prod-image-carousel-dot-container')
    
    prodImageCarouselParent.style.width = `${this.currentMedia.length}00%`
    prodImageCarouselParent.innerHTML = ''
    prodImageCarouselDotContainer.innerHTML = ''
    for(let i = 0; i < this.currentMedia.length; i++) {
      prodImageCarouselParent.appendChild(this.buildMedia(this.currentMedia[i]), i)
      prodImageCarouselDotContainer.appendChild(this.buildDot(i))
    }
    
    this.prodImageCarouselSwipeableElements = document.getElementsByClassName('prod-image-carousel-slide');
    this.prodImageCarouselSelectedIndex = this.isSuggestedPairing ? this.prodImageCarouselSelectedIndex : 0
    this.updateDots()
    this.prodImageCarouselSetScroll()
  }

  prodImageCarouselTouchstart(e) {
    this.prodImageCarouselTouch = new TouchEvent(e)
  }

  prodImageCarouselTouchend(e) {
    if (!this.prodImageCarouselTouch) return;
    this.prodImageCarouselTouch.setEndEvent(e);
    if (this.prodImageCarouselTouch.isSwipeRight()) this.prevProdImagePress();
    else if (this.prodImageCarouselTouch.isSwipeLeft()) this.nextProdImagePress();
    this.prodImageCarouselTouch = null;
  }

  buildMedia(media, index) {
    const newDiv = document.createElement('div')
    newDiv.classList.add('prod-image-carousel-slide', 'w-full', 'inline-block')
    newDiv.dataset.mediaType = media.type
    if (media.type == "image") {
      const image = document.createElement('img')
      image.classList.add('h-full', 'w-full', 'object-cover', 'object-center')
      image.src =  media.source
      image.dataset.index = index
      newDiv.appendChild(image)
    }

    if (media.type == "video") {
      const video = document.createElement('video')
      video.classList.add('h-full', 'm-auto', 'object-cover', 'object-center', 'pr-0')
      video.playsinline = true
      video.autoplay=false
      video.loop=false
      video.controls=true
      video.preload=true
      video.poster=media.thumbnail
      video.onclick = ()=>{this.checkAndPlayVideo()}

      const videoSource = document.createElement('source')
      videoSource.src =  media.source
      video.appendChild(videoSource)
      newDiv.appendChild(video)
    }
    return newDiv
  }

  buildDot(index) {
    const dot = document.createElement('div')
    dot.addEventListener('click', () => this.setProdImageCarouselIndex(index))
    dot.dataset.dotIndex = index
    dot.classList.add('prod-image-carousel-dot', 'w-3', 'h-3', 'rounded-full', 'mx-2', 'cursor-pointer', 'bg-gray-300')
    return dot
  }

  checkAndPlayVideo() {
    if (this.prodImageCarouselSwipeableElements[this.prodImageCarouselSelectedIndex].dataset.mediaType == "video") {
      const video = this.prodImageCarouselSwipeableElements[this.prodImageCarouselSelectedIndex].firstChild
      video.play()
    }
  }

  setProdImageCarouselIndex(index) {
    this.setprodImageCarouselAuto(); // Reset auto interval
    this.prodImageCarouselSelectedIndex = index;
    this.prodImageCarouselSetScroll();
  }

  updateDots() {
    const dots = document.getElementsByClassName('prod-image-carousel-dot')
    for (let i = 0; i < dots.length ; i ++) {
      if (dots[i].dataset.dotIndex == this.prodImageCarouselSelectedIndex){
        dots[i].classList.add('bg-copper')
        dots[i].classList.remove('bg-gray-300')
      } else{
        dots[i].classList.remove('bg-copper')
        dots[i].classList.add('bg-gray-300')
      }
    }
  }

  prodImageCarouselSetScroll() {
    const prodImageCarouselScrollDiv = document.getElementById('prod-carousel-scrolldiv');
    if (!prodImageCarouselScrollDiv) return;
    prodImageCarouselScrollDiv.scrollLeft = prodImageCarouselScrollDiv.clientWidth * this.prodImageCarouselSelectedIndex;
    this.updateDots()
  }

  prevProdImagePress() {
    if (this.prodImageCarouselSelectedIndex == 0) return;
    this.setprodImageCarouselAuto(); // Reset auto interval
    this.prodImageCarouselPrev();
  }

  nextProdImagePress() {
    this.setprodImageCarouselAuto(); 
    this.prodImageCarouselNext();
  }

  setprodImageCarouselAuto() {
    clearInterval(this.prodImageCarouselAutoInterval);
    this.prodImageCarouselAutoInterval = setInterval(this.prodImageCarouselNext.bind(this), 20000);
  }

  prodImageCarouselPrev() {
    if (this.prodImageCarouselSelectedIndex === 0) this.prodImageCarouselSelectedIndex = this.prodImageCarouselSwipeableElements.length - 1;
    else this.prodImageCarouselSelectedIndex--;
    this.prodImageCarouselSetScroll();
  }

  prodImageCarouselNext() {
    if (this.prodImageCarouselSelectedIndex === this.prodImageCarouselSwipeableElements.length - 1) this.prodImageCarouselSelectedIndex = 0;
    else this.prodImageCarouselSelectedIndex++;
    this.prodImageCarouselSetScroll();
  }

}